export const usePreviewInvitationCreateFlow = ({eventId}) => {
  const onPreviewInvitationClick = () => {
    window.open(`/event/${eventId}?preview=1&close=1`, '_blank');
  };

  return {onPreviewInvitationClick};
};
